<!--
  --
  -- 支払方法設定 ページ
  --
  -->
<template>
  <c-container form>
    <c-payment-list-card>
      <!-- カードのタイトル -->
      <template #title>お支払い方法を変更</template>

      <!-- 説明文 -->
      <template>
        <p>
          現在、登録頂いているお支払い方法の一覧です。
        </p>
      </template>

      <!-- 支払方法への追加操作 -->
      <template #itemActions="{userID, payment, update}">
        <v-btn
          class="ml-2"
          color="primary"
          :loading="running"
          :disabled="running || payment.defaultFlg !== 0"
          @click="onChangeDefault(userID, payment, update)"
        >
          通常
        </v-btn>
      </template>

      <!-- カードに表示するアクション -->
      <template #actions>
        <v-btn text outlined to="#back" class="ml-2" >OK</v-btn>
      </template>
    </c-payment-list-card>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CPaymentListCard from './CPaymentListCard'

import * as api from '@/api'
import { run } from '@/libs/a'

export default {
  name: 'Payment',
  mixins: [
    page('お支払い方法')
  ],
  components: {
    CPaymentListCard
  },
  data: () => ({
    // 通常の支払いに変更する操作中
    running: false
  }),
  methods: {
    onChangeDefault (userID, payment, update) {
      run(async () => {
        // 指定の支払方法を通常の支払いに変更する
        this.running = true
        await api.putUserPayment(userID, payment.payID, {
          defaultFlg: 1
        })
        this.running = false

        // リストを更新する
        update(true)
      })
    }
  }
}
</script>
